import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-cicd',
  imports: [CommonModule, RouterLink],
  templateUrl: './cicd.html',
  styleUrl: './cicd.css'
})
export class Cicd {
  features = [
    {
      title: 'Automated Build Pipelines',
      description: 'Continuous integration with automated builds triggered by code commits across GitHub, GitLab, and Bitbucket.',
      icon: 'build'
    },
    {
      title: 'Automated Testing Integration',
      description: 'Run unit tests, integration tests, and end-to-end tests automatically before deployment.',
      icon: 'testing'
    },
    {
      title: 'Zero-Downtime Deployments',
      description: 'Blue-green and canary deployments ensure your application stays available during updates.',
      icon: 'deployment'
    },
    {
      title: 'Multi-Environment Management',
      description: 'Seamlessly manage dev, staging, and production environments with environment-specific configurations.',
      icon: 'environments'
    },
    {
      title: 'Rollback Capabilities',
      description: 'Instant rollback to previous versions when issues are detected in production.',
      icon: 'rollback'
    },
    {
      title: 'Pipeline Monitoring & Alerts',
      description: 'Real-time visibility into pipeline status with Slack, email, and webhook notifications.',
      icon: 'monitoring'
    }
  ];

  process = [
    { step: 1, title: 'Pipeline Assessment', description: 'Analyze your current deployment process and identify automation opportunities.' },
    { step: 2, title: 'Pipeline Design', description: 'Design custom CI/CD workflows optimized for your tech stack and requirements.' },
    { step: 3, title: 'Implementation & Testing', description: 'Build and test pipelines with your team, ensuring all scenarios are covered.' },
    { step: 4, title: 'Optimization & Scale', description: 'Monitor pipeline performance and continuously optimize for speed and reliability.' }
  ];

  caseStudy = {
    client: 'FinanceFlow Inc',
    industry: 'Financial Services',
    image: 'https://images.unsplash.com/photo-1667372393119-3d4c48d07fc9?w=800&h=500&fit=crop',
    challenge: 'FinanceFlow was deploying manually once every 3-4 weeks, with each deployment taking 8 hours and frequently causing production incidents. Their development team was losing velocity due to slow feedback loops.',
    solution: 'We implemented a comprehensive CI/CD pipeline using Jenkins and AWS CodePipeline, with automated testing, security scanning, and zero-downtime blue-green deployments to production.',
    results: [
      { metric: '95%', description: 'Reduction in Deployment Time' },
      { metric: '10x', description: 'Increase in Deployment Frequency' },
      { metric: '78%', description: 'Decrease in Production Incidents' },
      { metric: '45min', description: 'Average Pipeline Execution Time' }
    ]
  };

  testimonial = {
    quote: 'The CI/CD pipeline HoneyKode built transformed how we ship software. We went from quarterly releases to deploying multiple times per day with confidence. The automated testing alone has saved us countless hours of manual QA.',
    author: 'James Patterson',
    role: 'CTO',
    company: 'FinanceFlow Inc',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop'
  };

  tools = [
    { name: 'Jenkins', category: 'CI/CD' },
    { name: 'GitLab CI', category: 'CI/CD' },
    { name: 'GitHub Actions', category: 'CI/CD' },
    { name: 'CircleCI', category: 'CI/CD' },
    { name: 'AWS CodePipeline', category: 'Cloud CI/CD' },
    { name: 'Azure DevOps', category: 'Cloud CI/CD' },
    { name: 'ArgoCD', category: 'GitOps' },
    { name: 'Spinnaker', category: 'Deployment' }
  ];
}
